import { render, staticRenderFns } from "./ThumbsDown.vue?vue&type=template&id=48f1fb39"
import script from "./ThumbsDown.vue?vue&type=script&lang=js"
export * from "./ThumbsDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports